import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageHeader from 'components/PageHeader';
import PageFooter from 'components/PageFooter';
import { AdminThemeProvider, useAdminTheme } from 'components/AdminThemeProvider';
import styles from './style.module.scss';
const PageContent = ({ children }) => {
    const { colorScheme } = useAdminTheme();
    return (_jsxs("div", { className: styles.page, "data-admin-theme": colorScheme, children: [_jsx(PageHeader, {}), _jsx("main", { className: styles.main, children: _jsx("div", { className: "container", children: children }) }), _jsx(PageFooter, {})] }));
};
const Page = ({ children }) => {
    return (_jsx(AdminThemeProvider, { children: _jsx(PageContent, { children: children }) }));
};
export default Page;
